import { create } from 'zustand';

export const useDialogStore = create((set, get) => ({
  open: false,
  title: '',
  message: '',
  variant: 'success',
  actions: undefined,
  onCloseCallback: undefined,

  openDialog: (config) =>
    set({
      open: true,
      ...config,
    }),

  closeDialog: () => {
    const callback = get().onCloseCallback;

    set({
      open: false,
      onCloseCallback: undefined,
    });

    callback?.();
  },
}));
